import React from 'react';

const SvgIconEspace = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <defs>
      <path
        id="prefix__a"
        d="M11.905 2A9.898 9.898 0 0 0 2 11.905a9.898 9.898 0 0 0 9.905 9.905 9.898 9.898 0 0 0 9.905-9.905A9.898 9.898 0 0 0 11.905 2zm7.119 14.405c-.357-.643-.953-.928-1.524-1.072-2.07-.523-2.951-1.166-3.286-1.547.12-.12.263-.238.382-.357 1.381-1.548 1.166-4.143 1.143-4.453-.143-2.832-2.096-3.833-3.738-3.833h-.143c-1.643 0-3.596 1-3.738 3.833-.024.31-.238 2.905 1.143 4.453.143.143.286.285.452.404-.357.405-1.262 1-3.239 1.5-.738.191-1.262.643-1.547 1.31a8.342 8.342 0 0 1-1.476-4.738c0-4.643 3.785-8.428 8.428-8.428 4.643 0 8.428 3.785 8.428 8.428a8.082 8.082 0 0 1-1.285 4.5z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlinkHref="#prefix__a" />
      </mask>
      <g fill="currentColor" mask="url(#prefix__b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);

export default SvgIconEspace;
